import { BullpenClassificationBase } from './base/bullpen-classification-base';

export class BullpenClassification extends BullpenClassificationBase { }